import { render, staticRenderFns } from "./DisabledCategoriesField.vue?vue&type=template&id=324ee957"
import script from "./DisabledCategoriesField.vue?vue&type=script&lang=js"
export * from "./DisabledCategoriesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports